import React, { ReactNode } from 'react';
import { ThemeProvider } from 'styled-components';
import defaultTheme from '../styles/themes/default';
import GlobalStyles from '../styles/global';
import { SidebarProvider } from './SidebarContext';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import { PaymentsProvider } from './Payments';
import { UserProvider } from './UserContext';
import { BatchPaymentProvider } from './BatchPaymentContext';
import { ContactComunixFormDataProvider } from './ContactComunixContext';
import { VehicleProvider } from './VehiclesContext';

const queryClient = new QueryClient();
interface GlobalContextProviderProps {
  children: ReactNode;
}

const GlobalContextProvider: React.FC<GlobalContextProviderProps> = ({
  children,
}) => {
  return (
    <UserProvider>
      <QueryClientProvider client={queryClient}>
        <SidebarProvider>
          <ThemeProvider theme={defaultTheme}>
            <VehicleProvider>
              <GlobalStyles />
              <BatchPaymentProvider>
                <ContactComunixFormDataProvider>
                  <PaymentsProvider>
                    {children}
                  </PaymentsProvider>
                </ContactComunixFormDataProvider>
              </BatchPaymentProvider>
            </VehicleProvider>
          </ThemeProvider>
        </SidebarProvider>
        <ReactQueryDevtools />
      </QueryClientProvider>
    </UserProvider>
  );
};

export default GlobalContextProvider;
